import { render, staticRenderFns } from "./UserVideos.vue?vue&type=template&id=412ee73a&"
import script from "./UserVideos.vue?vue&type=script&lang=js&"
export * from "./UserVideos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports